// extracted by mini-css-extract-plugin
export default {"dropdownItem":"dropdown-item_dropdownItem__HNwBA","caption":"dropdown-item_caption__mZiMd","occupation":"dropdown-item_occupation__2mP4Y"};